export default "__VITE_ASSET__546d652c__"